import i18next from 'i18next';

import Location from '@r6digital/rapidstor-types/react/entities/Location';

/**
 * Converts a monthly rate to its true weekly equivalent.
 * 12 months in a year, 52 weeks in a year.
 */
export const monthlyToWeekly = (monthlyValue: number): number => (monthlyValue * 12) / 52;

/**
 * Converts a monthly rate value to the location's billing period and returns
 * it as a locale-formatted number string (e.g. "90", "18.42").
 * No currency symbol or timeframe suffix is included.
 */
export const formatCurrency = (
    value: number,
    location: Location,
): string => {
    let valueToUse = value;
    if (!valueToUse) {
        valueToUse = 0;
    }
    if (location.rapidstor.showWeeklyRates) {
        if (location.settings.billingDefault === '28DayAnniversary') {
            valueToUse /= 4;
        } else {
            valueToUse = monthlyToWeekly(valueToUse);
        }
    }
    return Math.abs(valueToUse).toLocaleString('en-GB', {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        trailingZeroDisplay: 'stripIfInteger',
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
    });
};

/**
 * Formats a pre-converted number string into a full price label with currency
 * symbol and timeframe wording (e.g. "£90/mo", "£18.42/wk", "£90 per month").
 */
export const formatPriceLabel = (
    formattedValue: string,
    location: Location,
    longForm?: boolean,
    shortForm?: boolean,
): string => {
    let timeFrameString = '';
    if (longForm) {
        if (location.rapidstor.showWeeklyRates) {
            timeFrameString = ' per week';
        } else if (location.settings.billingDefault === '28DayAnniversary') {
            timeFrameString = ' per 4 weeks';
        } else {
            timeFrameString = ' per month';
        }
    }

    if (!longForm) {
        if (location.rapidstor.showWeeklyRates) {
            timeFrameString = i18next.t('time:per_week_short');
        } else if (location.settings.billingDefault === '28DayAnniversary') {
            timeFrameString = i18next.t('time:per_4_weeks_short');
        } else {
            timeFrameString = i18next.t('time:per_month_short');
        }
    }

    return `${location.rapidstor.currencySymbol}${formattedValue}${
        !shortForm ? timeFrameString : ''
    }`;
};
